var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { adminSystemIndexAPI } from '@/api/admin/config';
import { crmSettingConfigDataAPI } from '@/api/admin/crm';
import { adminConfigsetIndexAPI } from '@/api/admin/application';
import Lockr from 'lockr';
import merge from '@/utils/merge';
import { getImageData } from '@/utils/index.js';
var DefaultSystemAlertProps = {
    title: '',
    type: 'warning',
    description: '',
    closable: true,
    center: false,
    closeText: '',
    showIcon: true,
    effect: 'light'
};
/** 记录 侧边索引 */
export default {
    state: {
        logo: '',
        name: '',
        lang: localStorage.lang || 'cn',
        sidebar: {
            collapse: Lockr.get('sideBarCollapse') || false
        },
        // CRM配置信息
        CRMConfig: {},
        // 图片缓存
        imageCache: {},
        // 活动咨询是否开启
        marketingEnable: false,
        // 导航栏系统提示
        systemAlertShow: false,
        systemAlertProps: DefaultSystemAlertProps,
        // 模块权限
        moduleAuth: null,
        // 当前账套的月份
        nowMounth: '',
        cancelTokenArr: [],
        moduleData: {} // 各模块状态 包含 时间 次数等信息
    },
    mutations: {
        SET_NOWMOUNTH: function (state, num) {
            state.nowMounth = num;
        },
        SET_COLLAPSE: function (state, collapse) {
            state.sidebar.collapse = collapse;
            Lockr.set('sideBarCollapse', collapse);
        },
        SET_APPLOGO: function (state, logo) {
            state.logo = logo;
        },
        SET_APPNAME: function (state, name) {
            state.name = name;
        },
        SET_LANG: function (state, lang) {
            state.lang = lang;
            window.app.$i18n.locale = lang;
            localStorage.setItem('lang', lang);
            window.location.reload();
        },
        SET_CRMCONFIG: function (state, config) {
            state.CRMConfig = config;
        },
        SET_IMAGECACHE: function (state, value) {
            state.imageCache = value;
        },
        SET_MARKETINGENABLE: function (state, value) {
            state.marketingEnable = value;
        },
        SET_SYSTEMALERTSHOW: function (state, value) {
            state.systemAlertShow = value;
        },
        SET_SYSTEMALERTPROPS: function (state, value) {
            state.systemAlertProps = merge(__assign({}, DefaultSystemAlertProps), value || {});
        },
        SET_MODULEAUTH: function (state, value) {
            state.moduleAuth = value;
        },
        SET_CANCELTOKENARR: function (state, payload) {
            if (!state.cancelTokenArr) {
                state.cancelTokenArr = [];
            }
            state.cancelTokenArr.push(payload.cancelToken);
        },
        CLEAR_CANCELTOKENARR: function (_a) {
            var cancelTokenArr = _a.cancelTokenArr;
            cancelTokenArr && cancelTokenArr.length && cancelTokenArr.forEach(function (item) {
                item && item('路由跳转取消请求');
            });
            cancelTokenArr = [];
        },
        SET_MODULE_DATA: function (state, data) {
            state.moduleData = data;
        }
    },
    actions: {
        // 登录
        SystemLogoAndName: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                adminSystemIndexAPI({}).then(function (response) {
                    var resData = response.data || {};
                    commit('SET_APPNAME', resData.companyName);
                    commit('SET_APPLOGO', resData.companyLogo);
                    Lockr.set('systemLogo', resData.companyLogo);
                    Lockr.set('systemName', resData.companyName);
                    getImageData(resData.url)
                        .then(function (data) {
                        var wkLogoCache = Lockr.get('wkLogoCache') ? JSON.parse(Lockr.get('wkLogoCache')) : {};
                        // @ts-ignore
                        var userName = JSON.parse(localStorage.getItem('loginUserInfo')).username;
                        wkLogoCache[userName] = data.src;
                        Lockr.set('wkLogoCache', JSON.stringify(wkLogoCache));
                    }).catch(function () { });
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        /**
         * 获取客户管理配置
         */
        CRMSettingConfig: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                crmSettingConfigDataAPI({}).then(function (response) {
                    commit('SET_CRMCONFIG', response.data);
                    resolve(response);
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        // // 查询活动配置
        // QueryMarketing({
        //   commit,
        //   state
        // }) {
        //   return new Promise((resolve, reject) => {
        //     configQueryMarketingAPI().then(res => {
        //       state.marketingEnable = res.data == 1
        //       resolve(res)
        //     }).catch(error => {
        //       reject(error)
        //     })
        //   })
        // },
        // 查询模块权限
        QueryModules: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                adminConfigsetIndexAPI({}).then(function (res) {
                    var resData = res.data || [];
                    // status 状态 1:启用 0:停用 2:试用中 3:已过期,可用值:0,1,2,3
                    var auth = {};
                    resData.forEach(function (item) {
                        auth[item.module] = item.status === 1 || item.status === 2;
                    });
                    commit('SET_MODULEAUTH', auth);
                    commit('SET_MODULE_DATA', resData);
                    resolve(res);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }
};
